import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DialogContent from '../DialogContent';
import DialogActions from '../DialogActions';
import IncludedInsuranceList from '../../MUI/SummaryWrapper/IncludedInsuranceList';
import TitleTypography from '../../MUI/TitleTypography';
import ActiveCoverages from './ActiveCoverages';
import CloseIcon from '../../../icons/Close';
import { efesBorder } from '../../../theme';

import useStyles from '../makeStyles';

const AdditionalCoveragesDialog = ({
  selectedPlan,
  selectedPlansWithAllowedLimitRegionAndAge,
  onClose,
  open,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog
      fullWidth
      onClose={onClose}
      className={classes.root}
      aria-labelledby="coverages-dialog"
      open={open}
    >
      <DialogContent className={classes.contentRoot}>
        <div className={classes.header}>
          <TitleTypography>{t('insurance.includedInsurance')}</TitleTypography>
          <div
            role="presentation"
            className={classes.closeIcon}
            onClick={onClose}
          >
            <CloseIcon color={efesBorder} width={24} height={17} />
          </div>
        </div>
        {
          !!Object.keys(selectedPlansWithAllowedLimitRegionAndAge).length && (
          <IncludedInsuranceList plan={selectedPlansWithAllowedLimitRegionAndAge} />
          )
        }
        <ActiveCoverages selectedPlan={selectedPlan} />
      </DialogContent>
      <DialogActions>
        <div
          role="presentation"
          onClick={onClose}
          color="primary"
          className={classes.closeButton}
        >
          {t('menu.hide')}
        </div>
      </DialogActions>
    </Dialog>
  );
};

AdditionalCoveragesDialog.propTypes = {
  selectedPlansWithAllowedLimitRegionAndAge: PropTypes.shape({}),
  selectedPlan: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

AdditionalCoveragesDialog.defaultProps = {
  selectedPlansWithAllowedLimitRegionAndAge: {},
};

export default AdditionalCoveragesDialog;
